import { useState } from "react"
import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"
import ReadMoreCardComp from "./ReadMoreCardComp"
import { useNavigate } from "react-router-dom"


export const GeneralAverageClaimsReadmore = () => {


    const navigate = useNavigate()
    const handleReadmores = () => {
        navigate('/DoGA')
    }
    const data = [
        // {
        //     No: '1',
        //     img: "Static/Assets/Img/Principles/English Law.png",
        //     Title: "Edifice of General Average",
        //     bulletimg: "Static/Assets/Img/bullet-point.png"
        // },

        // {
        //     No: '2',
        //     img: "Static/Assets/Img/Principles/Continental Law.png",
        //     Title: "Edifice of General Average",
        //     bulletimg: "Static/Assets/Img/bullet-point.png"
        // },

        // {
        //     No: '3',
        //     img: "Static/Assets/Img/Principles/Amercian Law.png",
        //     Title: "Edifice of General Average",
        //     bulletimg: "Static/Assets/Img/bullet-point.png"
        // },
        {
            No: '4',
            img: "Static/Assets/Img/Parties Involved In Marine adventure HEXA FINAL.png",
            Title: "Parties Involved In Marine Adventure",
            bulletimg: "Static/Assets/Img/bullet-point.png"
        },
        {
            No: '5',
            img: "Static/Assets/Img/ga_contract-01.png",
            Title: "GA & Contracts Of Carriage / Insurance",
            bulletimg: "Static/Assets/Img/bullet-point.png"
        },
        {
            No: '6',
            img: "Static/Assets/Img/General Average tree.png",
            Title: "General Average (In Contracts of Marine Insurance)",
            bulletimg: "Static/Assets/Img/bullet-point.png"
        },
        {
            No: '7',
            img: "Static/Assets/Img/tree1.png",
            Title: "Nature of General Average",
            bulletimg: "Static/Assets/Img/bullet-point.png"
        },
        // {
        //     No: '7',
        //     img: "Static/Assets/Img/IMG_4519.jpg",
        //     Title: "Types of Losses",
        //     bulletimg: "Static/Assets/Img/bullet-point.png"
        // },
    ]

    const handleOpen = () => {
        window.open('https://milso.co.in/ppt/The%20Story%20of%20A%20Maritime%20Adventure%20Turned%20Mis-adventure.pdf')
    }

    return (
        <>
         <div className="container-fluid">
            <Header actives="GeneralAverageClaims" />
            <div className="container-fluid mt-lg-5  col-lg-11 mx-auto mt-5 pt-5" style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>

                {/* <div className="row col-lg-11 mx-auto my-5 "> */}
                {/* <div className="col-12 p-lg-5 faint p-4 mt-5" style={{ textAlign: 'justify', }}>
                        <div className="d-flex justify-content-center">
                            <div className="pe-1" style={{ width: '50%', textAlign: 'center' }}>
                                <div class="card cardHeight" >
                                    <div class="card-body">
                                        <p class="card-title text-center fw-bold" style={{ fontSize: "25px", textDecoration: 'underline' }}><img src="Static/Assets/Img/bullet-point.png" className='pe-2' style={{ height: "26px" }} />
                                            Who Invented General Average?
                                        </p>
                                        <h3 class="card-text p-2 text-center" style={{ fontSize: "24px" }}>
                                            "If general average didn't exist, someone would have had to invent it."
                                        </h3>
                                        <p class="card-text float-end text-center">The opening sentence of a magazine article in March 1989 <span>
                                            Quoted in <span className="fw-bold">General Average and York-Antwerp Rules
                                                By Lowndes and Rudolf </span> <br />
                                            (Twelfth Edition)
                                        </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div >
                            <h5 className="fw-bold gray_color pb-2 mt-3">General Average Claims</h5>

                            <p>General Average originated well before the concept of insurance, with respondensia and Bottamary Bonds issued by shipping merchants were originated. The following quotation comes from a chapter of Justinian's Digest prove the same. </p>
                        </div>
                    </div> */}
                <div className="row faint  my-5 pb-5">

                    <div className=" col-12 d-flex col-lg-8 mx-auto justify-content-center pt-5">
                        <div className="" style={{ textAlign: 'center' }}>
                            <div class="card px-5 py-2" >
                                <div class="card-body">
                                    <p class="card-title text-center fw-bold" style={{ fontSize: "25px", textDecoration: 'underline' }}><img src="Static/Assets/Img/bullet-point.png" className='pe-2' style={{ height: "26px" }} />
                                        THE RHODIAN LAW
                                    </p>

                                    <p class="card-text float-end text-center">
                                        "The Rhodian law* decrees that if in order to lighten a ship merchandise is thrown overboard, that which has been given for all should be replaced by the contribution of all. (* Cira 900 B.С.)"
                                    </p>
                                    <p className="float-end">- Digest of Justinian.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row py-5 faint">
                    <div className="col-12 col-lg-6 ps-lg-5">

                        <div className="card cardHeight d-flex flex-column shadow" style={{ borderRadius: "8px" }}>
                            <div class="card-body flex-grow-1 px-2">
                                <p class="card-title text-center fw-bold" style={{ fontSize: "21px", color: "#1c4c71", textTransform: 'uppercase' }}>
                                    General Average Statutory Definition
                                </p>
                                <p class="card-text p-2 text-center" >
                                    "There is a general average act where any extraordinary sacrifice or expenditure is voluntarily and reasonably made or incurred in time of peril for the purpose of preserving the property imperilled in the common adventure."
                                </p>
                                <div
                                    className="card-footer bg-white text-end border-0 d-flex align-items-center justify-content-end"
                                    style={{}}
                                >
                                    <span className="text-truncate d-inline-block" style={{ maxWidth: "100%" }}>
                                        - (Emphasis added) Sec. 66-Marine Insurance Act, 1906.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">

                        <div className="px-4 pt-3" style={{ position: 'relative', textAlign: 'justify' }}>
                            <p className="mb-0">
                                General Average is Strict Liability under Maritime Laws and Contractual Liability for the ship owners under Contract of carraige and Charter party Contracts. He insures these liabilites with the Hull and Machinery underwriters and with the Protection and Indemnity Clubs.
                                Cargo Owners covers their portion of General Average Contribution with the Cargo Underwriters.
                            </p>
                        </div>
                        <div className="px-4 pb-4" style={{ position: 'relative', textAlign: 'justify' }}>
                            <p>
                                Marine insurance claims, like non-marine claims, are categorized into two types: total loss and partial loss. General Average is a type of partial loss.
                                The subsequent flow chart depicts the overall view of the type of Marine claims.
                            </p>
                        </div>
                    </div>
                </div>

                <p class="card-title text-center fw-bold pt-5" style={{ textTransform: "uppercase", fontSize: "23px" }}>
                    Types of Losses
                </p>
                <div className="row faint px-5 " >

                    <div className="col-12 col-lg-8 mb-0">

                        <div className=" text-center ">
                            <img src="Static/Assets/Img/types of looses (2).png" alt="" className="img-fluid " style={{ height: "59vh" }} />
                        </div>
                    </div>

                    <div className="py-lg-5 col-lg-4" style={{ position: 'relative', textAlign: 'justify' }}>
                        <p className="pt-lg-5 mt-lg-3">
                            Let us have a look at the case study of M V “MSC SABRINA” - <strong>The Story Of A Marine Adventure Turned Misadventure, to understand the concept of General Average.</strong>
                        </p>
                        {/* <h6 className="fw-bold green">POST SABRINA PRESENTATION </h6> */}
                        <div className="" style={{ position: 'relative', textAlign: 'justify' }}>
                            {/* <p>
                                There are certain misconceptions about the "Declaration of General Average". Let us have a look at the flow chart, which lists the numerous outstanding questions date while dealing with the General Average situation, claims and contributions
                            </p> */}
                            <button className="btn button" onClick={handleOpen} >
                                <span> Read More </span>
                            </button>
                        </div>
                    </div>

                </div>


                {/* </div> */}


                {/* <div className="row col-lg-12 mx-auto">
                        <div className="col-12 " style={{ textAlign: 'justify', }}>
                            <div className="row "> */}

                {/* <ReadMoreCardComp
                                    Title="The RHODIAN Law"
                                    Discription="The Rhodian law* decrees that if in order to lighten a ship merchandise is thrown overboard, that which has been given for all should be replaced by the contribution of all. (* Cira 900 B.С.)"
                                    Des="- Digest of Justinian."
                                    className=''
                                    disClassName="card-text p-2 text-wrap"

                                /> */}

                {/* <ReadMoreCardComp
                                    Title="First Claim For General Average 1540"
                                    Discription="The first claim for general average contribution in English jurisprudence appears to have been Whitefield v Garrarede (File 8, No, 54 [1540]). The case involved a claim for general average contribution for jettisoning a boat and cargo from the Vessel Trinity James"
                                    Des="- The Law of Tug, Tow and Pilotage-Edward Cattell Jr. 3d Ed."
                                    disClassName="card-text p-2 text-wrap"
                                /> */}

                {/* <ReadMoreCardComp
                                    Title="Lord Kenyon and Lord Lawrence 1801"
                                    Discription="...all extra perils of the sea and ordinary losses and damages sustained by the ship happening immediately from the storm....must be borne by the shipowners. But all those articles which were made use by the master and crew upon the particular emergency and out of the usual course, for the benefit of the whole concern, and the other expenses must be paid proportionately"
                                    Des="- Birkley V Presgrave (1801) 1 East 220 at p 228."
                                    disClassName="card-text px-2 pt-2 text-wrap"

                                /> */}

                {/* <ReadMoreCardComp
                                    Title="Judge Uthwatt 1847"
                                    Discription="The principle involved in general average contribution is peculiar to the law of the sea and extends only to sea risks"
                                    Des="- Morrision S.S. Co. v. Greystoke Castle [1947] A.C. 265 at 310."
                                    disClassName="card-text p-2 text-wrap"

                                /> */}
                {/* <ReadMoreCardComp
                                    Title="Lord Gorell Barnes 1893"
                                    Discription="The obligation to contribute in general average exists between the parties to the adventure whether they are insured or not. The circumstances of the party being insured can have no influence upon the adjustment of general average, the rules of which are independent of insurance"
                                    Des="- The Brigella (1893) p 189 at p 195."
                                    disClassName="card-text p-2 text-wrap"

                                /> */}
                {/* <ReadMoreCardComp
                                    Title="Lord Justice A.L. Smith 1900"
                                    Discription="The liability to contribute in no sense results from the contract of carriage, but is founded upon a loss which arises in consequence of extraordinary sacrifices made or expenses incurred for the preservation of the ship and cargo in the time of, peril and which must be borne proportionately by all those who are interested"
                                    Des=""
                                    disClassName="card-text p-2 text-wrap"
                                /> */}
                {/* </div>
                        </div>
                    </div> */}

                <div className="row pt-4" >
                    {
                        data && data.length > 0 && data.map((i, j) => {
                            return (
                                <div className="col-12 mx-0 px-0   mb-5">
                                    <p class="card-title text-center fw-bold py-2 pt-4" style={{ textTransform: "uppercase", fontSize: "23px" }}>
                                        {i.Title}
                                    </p>
                                    <div className="card py-3 " style={{ borderRadius: "0px", border: '0px', backgroundColor: "#bdd1e169" }} >

                                        <div className="pt-2 text-center ">
                                            <img src={i.img} alt="" className="img-fluid " style={{ height: "60%", width: "60%" }} />
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        )
                    }
                </div>
                {/* <div className="row pb-lg-0">
                                <div className="col-12 px-lg-5 pb-1"> */}
                {/* <div className="row">
                                        <div className="col-0 col-lg-2"></div>
                                        <div className="col-12 col-lg-8">
                                            <div className="card cardHeight d-flex flex-column shadow" style={{ borderRadius: "8px" }}>
                                                <div class="card-body flex-grow-1 p-2">
                                                    <p class="card-title text-center fw-bold" style={{ fontSize: "21px", color: "#1c4c71" }}>
                                                        <img src="Static/Assets/Img/bullet-point.png" className='pe-2' style={{ height: "22px" }} />
                                                        General Average Statutory Definition
                                                    </p>
                                                    <p class="card-text p-2 text-center" >
                                                        "There is a general average act where any extraordinary sacrifice or expenditure is voluntarily and reasonably made or incurred in time of peril for the purpose of preserving the property imperilled in the common adventure."
                                                    </p>
                                                    <div
                                                        className="card-footer bg-white text-end border-0 d-flex align-items-center justify-content-end"
                                                        style={{ minHeight: "88px" }}
                                                    >
                                                        <span className="text-truncate d-inline-block" style={{ maxWidth: "100%" }}>
                                                            - (Emphasis added) Sec. 66-Marine Insurance Act, 1906.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-0 col-lg-2"></div>
                                    </div> */}
                {/* <div className="p-4" style={{ position: 'relative', textAlign: 'justify' }}>
                                        <p>
                                            General Average is Strict Liability under Maritime Laws and Contractual Liability for the ship owners under Contract of carraige and Charter party Contracts. He insures these liabilites with the Hull and Machinery underwriters and with the Protection and Indemnity Clubs.
                                            Cargo Owners covers their portion of General Average Contribution with the Cargo Underwriters.
                                        </p>
                                    </div> */}
                {/* <div className="px-4 pb-4" style={{ position: 'relative', textAlign: 'justify' }}>
                                        <p>
                                            Marine insurance claims, like non-marine claims, are categorized into two types: total loss and partial loss. General Average is a type of partial loss.
                                            The subsequent flow chart depicts the overall views of the Marine claims components.
                                        </p>
                                    </div> */}
                {/* <div className="row pt-3 px-3" >
                                        <div className="card pt-3 ">
                                            <div className="col-12 col-lg-12 mb-0">
                                                <p class="card-title text-center fw-bold" style={{ textTransform: "uppercase", fontSize: "23px" }}><img src="Static/Assets/Img/bullet-point.png" className='pe-2' style={{ height: "28px" }} />
                                                    Types of Losses
                                                </p>
                                                <div className="pb-5 text-center ">
                                                    <img src="Static/Assets/Img/types of looses (2).png" alt="" className="img-fluid " style={{ height: "65vh", width: "60vw" }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-4" style={{ position: 'relative', textAlign: 'justify' }}>
                                            <p>
                                                Let us have a look at the case study of M V “MSC SABRINA” - <strong>The Story Of A Marine Adventure Turned Misadventure, to understand the concept of General Average.</strong>
                                            </p>
                                        </div>
                                        <div className="col-lg-12 text-start pb-2 ps-4">
                                            <h6 className="fw-bold green">POST SABRINA PRESENTATION </h6>
                                        </div>

                                        <div className="col-12 pe-lg-5 pb-5 ps-lg-4 ps-4">
                                            <div className="" style={{ position: 'relative', textAlign: 'justify' }}>
                                                <p>
                                                    There are certain misconceptions about the "Declaration of General Average". Let us have a look at the flow chart, which lists the numerous outstanding questions date while dealing with the General Average situation, claims and contributions
                                                </p>
                                                <button className="btn button" onClick={handleOpen} >
                                                    <span> Download PPT</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div> */}

                {/* </div>
                            </div> */}


                <div className="row mb-5  " style={{ backgroundColor: '#bdd1e169' }}>


                    <div className="p-lg-5 " style={{ position: 'relative', textAlign: 'justify' }}>

                        {/* <h6 className="fw-bold green">POST SABRINA PRESENTATION </h6>
                        <div className="" style={{ position: 'relative', textAlign: 'justify' }}>
                            <p>
                                There are certain misconceptions about the "Declaration of General Average". Let us have a look at the flow chart, which lists the numerous outstanding questions date while dealing with the General Average situation, claims and contributions
                            </p>

                        </div> */}

                        <p className=" text-center">
                            <button className="btn button py-3 px-5" onClick={handleReadmores}>
                                <span> Read More</span>
                            </button>
                        </p>

                    </div>



                </div>
            </div>
            <Footer />
</div>
        </>
    )
}
